import { Component, h, Host, Prop } from "@stencil/core";
import { getCompanyLinks, staticSocialLinks } from "./api";

@Component({
    tag: "ux-iws-sf-page-footer",
    styleUrl: "sf-page-footer.scss",
    shadow: false,
})
export class SfPageFooter {
    /** Locale used to localize texts and links */
    @Prop() locale: string = "de_DE";

    render() {
        return (
            <Host>
                <footer class="ux-iws-footer">
                    <div class="ux-t-container">
                        <div class="ux-iws-footer__social-icons">
                            {staticSocialLinks.map((link) => (
                                <a
                                    key={`${link.label}-${link.href}`}
                                    class="ux-button ux-button--icon-only"
                                    target="_blank"
                                    href={link.href}
                                    aria-label={link.label}
                                >
                                    <ux-icon name={link.icon}></ux-icon>
                                </a>
                            ))}
                        </div>
                        <ul class="ux-text-tiny ux-iws-footer__bottom-links">
                            {getCompanyLinks(this.locale).map((link) => (
                                <li key={`${link.label}-${link.href}`}>
                                    <a
                                        href={link.href}
                                        data-ux-cookie-layer={
                                            link.privacySettings
                                                ? "settings"
                                                : undefined
                                        }
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <div class="ux-u-text-align--center ux-u-mt-xxs">
                            <div class="ux-text-tiny ux-u-text-uppercase">{`© ${new Date().getFullYear()} Trumpf`}</div>
                        </div>
                    </div>
                </footer>
            </Host>
        );
    }
}
